import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const isTypoUtility = (classPart: string) => /^typo-.*$/.test(classPart);

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [isTypoUtility],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
